import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import { Box, Grid, TextField, Button, FormControlLabel, FormGroup, Checkbox, FormControl, Select, MenuItem, InputLabel, Link } from '@mui/material';
import DebitCard from '../DebitCard/DebitCard';
import EmiTable from '../CommonDetails/EmiTable';
import BankDetails from '../ChildComponents/BankDetails';
import EmiCardDetails from '../ChildComponents/EMiDebitCardDetails';
import CardlessEmiDetails from '../ChildComponents/CardlessEmi';
import NcemiDebitCardDetails from '../ChildComponents/NcemiDebitCardDetails';
import NcemiCreditCardDetails from '../ChildComponents/NcemiCreditCardDetails';
import Loader from '../../Components/loader';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


 
export default function NcemiTabs({apiData}) {
  
  const [bankList, setBankList] = useState(null);
  const [DCbankList, setDCBankList] = useState(null);
  const [selectBankCode, setBankCode] = useState('');
  const [selectDCBankCode, setDCBankCode] = useState('');
  const [value, setValue] = React.useState(0);
  const [codeList , setcodeList] = useState('');
  const [DCcodeList , setDCcodeList] = useState('');
  const [cardlessBankList , setCardlessBankList] = useState(null);
  const [showLoader, setshowLoader] = useState(false);
  const [showBanks, setShowBanks] = useState(true);
  const [showDCBanks, setShowDCBanks] = useState(true);
  const [showCardForm, setShowCardForm] = useState(false);
  const [showDCCardForm, setShowDCCardForm] = useState(false);
  const [NBerror, setNBerror] = useState(false);
  const [mode , setMode] = useState('');
  const [bankId , setBankId] = useState('');
  const [selectEmiCode, setSelectEmiCode] = useState('');
  const [orderedModes, setOrderedModes] = useState([]);
  
  let selectBankName;
  const handleBankCodeSelection = (bankCode) => {
    setSelectEmiCode(bankCode);
  };

 
  let secret;
  const cardlessMode = 'NCEMI';
     useEffect(() => {
        if (apiData) {
            
            secret = apiData.secret;
            const payModesToPass =  apiData.beans.payModes;
            // Build available NCEMI modes and compute ordering
            const supported = ['NCEMI', 'NCEMI_DC', 'NCEMI_CARDLESS'];
            const defaultIndex = (base) => (base === 'NCEMI' ? 0 : base === 'NCEMI_DC' ? 1 : 2);
            const parsedModes = (payModesToPass || [])
              .map(method => {
                if (!method || !method.code) return null;
                const parts = String(method.code).split('-');
                const base = parts[0];
                if (!supported.includes(base)) return null;
                const idxStr = parts[1];
                const idxNum = idxStr !== undefined && !Number.isNaN(parseInt(idxStr, 10)) ? parseInt(idxStr, 10) : defaultIndex(base);
                return { base, index: idxNum, method };
              })
              .filter(Boolean)
              .sort((a, b) => a.index - b.index);
            let finalOrderBases = parsedModes.map(m => m.base);
            // Read preferred ordering ONLY from subpaymodesOrder
            const preferenceCandidates = [
              apiData && apiData.subpaymodesOrder,
              apiData && apiData.beans && apiData.beans.subpaymodesOrder
            ];
            const normalizedCandidates = preferenceCandidates
              .map(v => {
                if (Array.isArray(v)) return v.join(',');
                if (typeof v === 'string') return v;
                return undefined;
              })
              .filter(Boolean);
            const prefRaw = normalizedCandidates.find(v => typeof v === 'string' && v.trim().length > 0);
            if (prefRaw) {
              try {
                const normalized = String(prefRaw).trim();
                let preferList = [];
                if (normalized.includes(':')) {
                  // Parse multi-category input and extract NCEMI segment values
                  const parts = normalized.split(',').map(p => p.trim());
                  let currentCategory = null;
                  const categoryToValues = {};
                  parts.forEach(p => {
                    if (p.includes(':')) {
                      const [cat, val] = p.split(':');
                      currentCategory = String(cat || '').trim().toUpperCase();
                      const value = String(val || '').trim().toUpperCase();
                      if (!categoryToValues[currentCategory]) categoryToValues[currentCategory] = [];
                      if (value) categoryToValues[currentCategory].push(value);
                    } else if (currentCategory) {
                      const value = String(p || '').trim().toUpperCase();
                      if (!categoryToValues[currentCategory]) categoryToValues[currentCategory] = [];
                      if (value) categoryToValues[currentCategory].push(value);
                    }
                  });
                  preferList = (categoryToValues['NCEMI'] || []);
                } else {
                  // Plain CSV applies directly
                  preferList = normalized
                    .split(',')
                    .map(s => String(s || '').trim().toUpperCase())
                    .filter(Boolean);
                }
                const present = new Set(finalOrderBases);
                const orderedFirst = preferList.filter(b => present.has(b));
                const remaining = finalOrderBases.filter(b => !orderedFirst.includes(b));
                finalOrderBases = [...orderedFirst, ...remaining];
              } catch (e) {
                // ignore parse errors; keep default
              }
            }
            setOrderedModes(finalOrderBases);
            const subPayMode = parsedModes.find(m => m.base === 'NCEMI')?.method;
            const subPayModeDC = parsedModes.find(m => m.base === 'NCEMI_DC')?.method;
            const subPayModeCardless = parsedModes.find(m => m.base === 'NCEMI_CARDLESS')?.method;
            const EMIBanks = subPayMode ? subPayMode.subPayModes : null;
            const DCBanks = subPayModeDC ? subPayModeDC.subPayModes : null;
            const cardLess = subPayModeCardless ? subPayModeCardless.subPayModes : null;
            setBankList(EMIBanks);
            setDCBankList(DCBanks);
            setCardlessBankList(cardLess);
            var bankcodes = [];
            var DCbankcodes = [];
            var cardlessCode = [];
            if(EMIBanks){
            EMIBanks.forEach(function(item) {
            bankcodes.push(item.code);
            });
		setcodeList(bankcodes);	
	  }
	  
	  if(DCBanks){
            DCBanks.forEach(function(item) {
            DCbankcodes.push(item.code);
            });
		setDCcodeList(DCbankcodes);
	  }
	  
	  if(cardLess){
            cardLess.forEach(function(item) {
            cardlessCode.push(item.code);
            console.log('NCEMI_CARDLESS subPayModes codes:', cardlessCode);
            });
            // Reorder cardless using ONLY subsubpaymodesOrder like "NCEMI_CARDLESS:241,239"
            try {
              const prefSources = [
                typeof (apiData && apiData.subsubpaymodesOrder) === 'string' && apiData.subsubpaymodesOrder,
                typeof (apiData && apiData.beans && apiData.beans.subsubpaymodesOrder) === 'string' && apiData.beans.subsubpaymodesOrder
              ].filter(Boolean);
              let preferredKeys = null;
              for (const src of prefSources) {
                if (typeof src === 'string') {
                  const m = src.match(/(NCEMI[_\s-]?CARDLESS|NCEMICARDLESS)\s*:\s*([0-9,\s]+)/i);
                  if (m && m[2]) {
                    preferredKeys = m[2].split(',').map(s => s.trim()).filter(Boolean);
                    break;
                  }
                }
              }
              if (preferredKeys && preferredKeys.length > 0) {
                const seen = new Set();
                const ordered = [];
                preferredKeys.forEach(k => {
                  if (cardlessCode.includes(k) && !seen.has(k)) {
                    ordered.push(k);
                    seen.add(k);
                  }
                });
                const remaining = cardlessCode.filter(c => !seen.has(c));
                cardlessCode = [...ordered, ...remaining];
              }
            } catch (e) {}
		setCardlessBankList(cardlessCode);
	  }
	
       }
    }, [apiData]); 
     
     useEffect(() => {
     if(selectBankCode>0){
     setNBerror(false);
     const selectedBank = bankList.find(bank => bank.code === selectBankCode);
     selectBankName = selectedBank.name;
     setMode('NCEMI');
  }
     }, [selectBankCode]); 
     
     
    useEffect(() => {
     if(selectDCBankCode>0){
     setNBerror(false);
     const selectedDCBank = DCbankList.find(bank => bank.code === selectDCBankCode);
     selectBankName = selectedDCBank.name;
     setMode('NCEMI_DC');
  }
     }, [selectDCBankCode]); 
   
  const EMIhandleChange = (event) => {
  const selectedBankCode = event.target.value;
  setBankCode(selectedBankCode); 
  setMode('NCEMI');

 };
  
   const handleDCCloseDialog = () => {
     setMode('NCEMI_DC');
     setShowDCBanks(true); 
     setShowDCCardForm(false);
  };


     
 const handleCloseDialog = () => {
     setMode('NCEMI');
     setShowBanks(true);  
     setShowCardForm(false);
  };
  
  
   const DCEMIhandleChange = (event) => {
  const selectedBankCode = event.target.value;
  setDCBankCode(selectedBankCode); 
  setMode('NCEMI_DC');

 };
  

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
 
 const handleBankSelect = async () => {
   if(selectBankCode>0){
   setShowBanks(false); 
   setShowCardForm(true);
   }else{
    setNBerror(true);
   }
 }
 const handleDCBankSelect = async () => {
   if(selectDCBankCode>0){
   setShowDCBanks(false); 
   setShowDCCardForm(true);
   }else{
    setNBerror(true);
   }
  }
 
 
 
  const handleTabChange = async () => {
  
   setShowBanks(true);
   setShowDCBanks(true); 
   setShowCardForm(false);
   setShowDCCardForm(false);
   setBankCode('');
   setDCBankCode('');
 
 }

  const handleSelectChange = (event) => {
    //setBankName(event.target.value);
  };

  return (
    <>

   {showLoader && <Loader show={true} textToShow="Please wait while your transaction is being processed"/>}

    <div className='card-details'>
      <div className="card-detail-form">
        <h5>Select an option</h5>
        <Box sx={{ width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} className="tab-header" variant="scrollable" onChange={handleChange} aria-label="scrollable auto tabs example"
              TabIndicatorProps={{
                style: { display: 'none', position: 'unset' }
              }}>

           {orderedModes
             .filter(base => {
               if (base === 'NCEMI') return !!bankList;
               if (base === 'NCEMI_DC') return !!DCbankList;
               if (base === 'NCEMI_CARDLESS') return Array.isArray(cardlessBankList) && cardlessBankList.length > 0;
               return false;
             })
             .map((base, idx) => {
             if (base === 'NCEMI' && bankList) {
               return <Tab key={base} label="Credit Card" {...a11yProps(idx)} onClick={handleTabChange}/>;
             }
             if (base === 'NCEMI_DC' && DCbankList) {
               return <Tab key={base} label="Debit Card" {...a11yProps(idx)} onClick={handleTabChange} />;
             }
             if (base === 'NCEMI_CARDLESS') {
               return <Tab key={base} label="Cardless EMI" {...a11yProps(idx)} onClick={handleTabChange} />;
             }
             return null;
           })}
            </Tabs>
          </Box>
          {orderedModes
            .filter(base => {
              if (base === 'NCEMI') return !!bankList;
              if (base === 'NCEMI_DC') return !!DCbankList;
              if (base === 'NCEMI_CARDLESS') return Array.isArray(cardlessBankList) && cardlessBankList.length > 0;
              return false;
            })
            .map((base, idx) => {
            if (base === 'NCEMI') {
              return (
          <CustomTabPanel key={base} value={value} index={idx}>
           {bankList && showBanks && <div> <div className='card-info'>
              <ul>

                 {codeList && codeList.includes("21") && (
           <li className={selectBankCode === '21' ? 'active' : ''} onClick={() => setBankCode('21')}>
                  <Link>
                    <img src="./images/hdfc.svg" alt="hdfc" /> <span>HDFC</span>
                  </Link>
                </li>
                )}
                 {codeList && codeList.includes("22") && (
           <li className={selectBankCode === '22' ? 'active' : ''} onClick={() => setBankCode('22')}>

                  <Link>
                    <img src="./images/icici.svg" alt="icici" /> <span>ICICI</span>
                  </Link>
                </li>
                )}
                 {codeList && codeList.includes("48") && (
           <li className={selectBankCode === '48' ? 'active' : ''} onClick={() => setBankCode('48')}>

                  <Link>
                    <img src="./images/sbi.svg" alt="SBi" /> <span>SBI</span>
                  </Link>
                </li>
                )}
                 {codeList && codeList.includes("32") && (
           <li className={selectBankCode === '32' ? 'active' : ''} onClick={() => setBankCode('32')}>

                  <Link>
                    <img src="./images/kotak_mahindra.svg" alt="Kotak Mahindra" /> <span>Kotak Mahindra</span>
                  </Link>
                </li>
                )}
                 {codeList && codeList.includes("39") && (
           <li className={selectBankCode === '39' ? 'active' : ''} onClick={() => setBankCode('39')}>

                  <Link>
                    <img src="./images/PNB.svg" alt="PNB" /> <span>Punjab National Bank</span>
                  </Link>
                </li>
                )}
                 {codeList && codeList.includes("6") && (
           <li className={selectBankCode === '6' ? 'active' : ''} onClick={() => setBankCode('6')}>

                  <Link>
                    <img src="./images/BOB.svg" alt="hdfc" /> <span>Bank of Baroda</span>
                  </Link>
                </li>
                )}
              </ul>
            </div>
            <Grid container spacing={3}>
              <Grid item md={12} xs={12} >
                <FormControl fullWidth className='form-control'>
                  <InputLabel id="demo-simple-select-label">Select another bank</InputLabel>
                   <Select
 			 labelId="demo-simple-select-label"
  			 id="demo-simple-select"
  			 value={selectBankCode}
  			 label="Bank Name"
			 onChange={EMIhandleChange}
 			 >
                    {bankList && bankList.map((bank, index) => (
                  <MenuItem key={index} value={bank.code}>
                  {bank.name}
                   </MenuItem>
                   ))}
                  </Select>
                </FormControl>
              </Grid>
               {NBerror && (
  <p style={{ color: 'red', paddingTop: '10px', marginLeft: '27px' }}>
    Please select a bank!
  </p>
)}		
              <Grid item md={12} xs={12}>
                <Button variant="outlined" size="large" className='pay-now-btn' onClick={handleBankSelect}>
                  Continue
                </Button>
              </Grid>
            </Grid> </div>}
           
           {showCardForm && <NcemiCreditCardDetails secret={apiData.secret} bankCode = {selectBankCode} mode={mode} displayOrderNo={apiData.displayOrderNo} bankList = {bankList} handleCloseDialog={handleCloseDialog}/>}
         
          </CustomTabPanel>
              );
            }
            if (base === 'NCEMI_DC') {
              return (
          <CustomTabPanel value={value} index={idx}>
         {DCbankList && showDCBanks && <div> <div className='card-info'>
              <ul>
              {DCcodeList && DCcodeList.includes("21") && (
           <li className={selectDCBankCode === '21' ? 'active' : ''} onClick={() => setDCBankCode('21')}>
                  <Link>
                    <img src="./images/hdfc.svg" alt="hdfc" /> <span>HDFC</span>
                  </Link>
                </li>
                )}
                 {DCcodeList && DCcodeList.includes("22") && (
           <li className={selectDCBankCode === '22' ? 'active' : ''} onClick={() => setDCBankCode('22')}>

                  <Link>
                    <img src="./images/icici.svg" alt="icici" /> <span>ICICI</span>
                  </Link>
                </li>
                )}
                 {DCcodeList && DCcodeList.includes("48") && (
           <li className={selectDCBankCode === '48' ? 'active' : ''} onClick={() => setDCBankCode('48')}>

                  <Link>
                    <img src="./images/sbi.svg" alt="SBi" /> <span>SBI</span>
                  </Link>
                </li>
                )}
                 {DCcodeList && DCcodeList.includes("32") && (
           <li className={selectDCBankCode === '32' ? 'active' : ''} onClick={() => setDCBankCode('32')}>

                  <Link>
                    <img src="./images/kotak_mahindra.svg" alt="Kotak Mahindra" /> <span>Kotak Mahindra</span>
                  </Link>
                </li>
                )}
                 {DCcodeList && DCcodeList.includes("39") && (
           <li className={selectDCBankCode === '39' ? 'active' : ''} onClick={() => setDCBankCode('39')}>

                  <Link>
                    <img src="./images/PNB.svg" alt="PNB" /> <span>Punjab National Bank</span>
                  </Link>
                </li>
                )}
                 {DCcodeList && DCcodeList.includes("6") && (
           <li className={selectDCBankCode === '6' ? 'active' : ''} onClick={() => setDCBankCode('6')}>

                  <Link>
                    <img src="./images/BOB.svg" alt="hdfc" /> <span>Bank of Baroda</span>
                  </Link>
                </li>
                )}   
                </ul>
            </div>
            <Grid container spacing={3}>
              <Grid item md={12} xs={12} >
                <FormControl fullWidth className='form-control'>
                  <InputLabel id="demo-simple-select-label">Select another bank</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectDCBankCode}
                    label="Bank Name"
                    onChange={DCEMIhandleChange}
                  >
                  {DCbankList && DCbankList.map((bank, index) => (
                  <MenuItem key={index} value={bank.code}>
                  {bank.name}
                   </MenuItem>
                   ))}
                  </Select>
                </FormControl>
              </Grid>
               {NBerror && (
	  <p style={{ color: 'red', paddingTop: '10px', marginLeft: '27px' }}>
  	  Please select a bank!
 	 </p>
		)}		
             <Grid item md={12} xs={12}>
                <Button variant="outlined" size="large" className='pay-now-btn' onClick={handleDCBankSelect}>
                  Continue
                </Button>
              </Grid>
            </Grid></div>}
           {showDCCardForm && <NcemiDebitCardDetails secret={apiData.secret} bankCode = {selectDCBankCode} mode={mode} displayOrderNo={apiData.displayOrderNo} bankList = {DCbankList}      handleDCCloseDialog={handleDCCloseDialog} amount = {apiData.amount}/>}
          </CustomTabPanel>
              );
            }
            if (base === 'NCEMI_CARDLESS') {
              return (
          <CustomTabPanel value={value} index={idx}>
            <CardlessEmiDetails cardlessBankList={cardlessBankList} mode = {cardlessMode} secret = {apiData.secret} amountToBePaid = {apiData.amount}/>
          </CustomTabPanel>
              );
            }
            return null;
          })}
        </Box>
      </div>
    </div>
    </>
  );
}
